import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import FilterListIcon from '@mui/icons-material/FilterList'
import { Avatar, Box, Button, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography, Link } from '@mui/material'
import React from 'react'
import clsx from 'clsx'
import { ArrowBack } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { playlistSlice } from '../../reducers'
import { useFormFactor } from '../../hooks'
import { useStyles } from './style'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { contentUrl } from '../../helpers/url'
import { usePlaylistContext } from '../playlist-progress/context'
import Skeleton from '@mui/material/Skeleton'
import useBack from '../playlists/detail/useBack'

const PlaylistNavigation = ({ title, playlistContextId, playlistDetail, playlistContent }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)
  const dispatch = useDispatch()
  const { isDesktop } = useFormFactor()
  const navigate = useNavigate()
  const { isMarkedAsRead, isComplete } = usePlaylistContext()
  const back = useBack()

  const handleBackToLandingPage = () => {
    back.nav()
    dispatch(playlistSlice.actions.reset())
  }

  const handleBackToDetailPage = () => {
    navigate(`/playlists/${playlistDetail.pk.split('playlist#').join('')}`)
    dispatch(playlistSlice.actions.reset())
  }

  const toggleNav = () => {
    if (isDesktop) return
    setExpanded(!expanded)
  }

  const arrowDirection = expanded ? classes.arrowDown : classes.arrowUp

  const LinkType = ({ children, item }) => {
    if (item?.type === 'external') {
      return (
        <Link
          component='a'
          target='_blank'
          className={classes.playlistLink}
          href={item.url}
          rel='noopener noreferrer'
        >
          {children}
        </Link>
      )
    }
    return (
      <RouterLink
        to={contentUrl(item, 'playlist-nav', null, { playlistId: playlistContextId })}
        target=''
        className={classes.playlistLink}
      >
        {children}
      </RouterLink>
    )
  }

  return (
    <Grid
      container
      display='flex'
      flexDirection='row'
      flex='1'
      className={classes.root}
    >
      <Grid
        display='flex'
        flexDirection='row'
        alignContent='flex-start'
        item xs={12}
        className={classes.backButtonContainer}
      >
        <Button
          variant='text'
          startIcon={<ArrowBack />}
          onClick={handleBackToDetailPage}
          data-test='back-button'
        >
          Back to Playlist
        </Button>
      </Grid>
      <Grid
        display='flex'
        alignContent='center'
        flexDirection='column'
        item xs={12}
        flex='1'
        onClick={toggleNav}
        className={clsx(classes.navContainer, expanded && classes.navContainerExpanded)}
      >
        <Box
          display='flex'
          flexDirection='row'
          justifyContent='center'
          className={classes.navHeader}
        >
          <ExpandCircleDownIcon className={clsx(classes.arrowIcon, expanded && arrowDirection)} />
          <Typography variant='h6' className={classes.title} noWrap data-test='article-toolbar-title'>
            {playlistDetail?.title ? playlistDetail.title : <Skeleton className={classes.skeleton} variant='rectangular' height={40} />}
          </Typography>
          <FilterListIcon className={classes.filterIcon} style={{ display: 'none' }} />
        </Box>
        <Divider variant='fullWidth' className={classes.divider} />
      </Grid>
      {(expanded || isDesktop) &&
        <Grid
          display='flex'
          flexDirection='column'
          item xs={12}
          className={classes.whatsNextContainer}
        >
          {!isComplete(playlistContextId) && (
            <>
              <Typography variant='h6' className={classes.whatsNewText} noWrap data-test='article-toolbar-title'>
                What&apos;s next?
              </Typography>

              <List role='navigation' className={classes.playlistItems}>
                {!playlistContent.length &&
                Array(4).fill().map((item, idx) => (
                  <ListItem key={idx} className={classes.playlistItem}>
                    <Skeleton className={classes.skeleton} variant='rectangular' height={40} />
                  </ListItem>
                ))}
                {!!playlistContent.length &&
                playlistContent.map((item, index) => (
                  <ListItem key={index} className={classes.playlistItem}>
                    <LinkType item={item}>
                      <ListItemAvatar>
                        <Avatar alt={item?.image?.altText} src={item?.image?.imgUrl} variant='rounded' className={classes.avatar} />
                      </ListItemAvatar>
                      <Box
                        display='flex'
                        flexDirection='column'
                      >
                        <ListItemText
                          primary={item.title} className={clsx(classes.linkText, item.title === title && classes.linkTextBold)}
                        />
                        {isMarkedAsRead(playlistContextId, item?.type === 'external' ? item.friendlyUrl : item.locationId) && (
                          <Typography variant='caption' noWrap className={classes.viewedText}>
                            Viewed
                          </Typography>
                        )}
                      </Box>
                    </LinkType>
                  </ListItem>
                ))}
              </List>
            </>
          )}
          {isComplete(playlistContextId) && (
            <Grid
              display='flex'
              alignContent='center'
              flexDirection='column'
              item xs={12}
              className={classes.completeContainer}
            >
              <Typography variant='h7' className={classes.completeText}>
                Congratulations! 🎉
                <br />
                You&apos;ve explored this playlist.
              </Typography>
              <Box className={classes.exploreMore}>
                <Typography className={classes.exploreMoreText}>
                  Remember, there are more playlists to discover.
                  <br />
                  <Link
                    to='#'
                    target=''
                    onClick={handleBackToLandingPage}
                  >
                    Explore more
                  </Link>
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>}
    </Grid>
  )
}

export default PlaylistNavigation
